<template>
  <v-dialog
    :value="value"
    width="fit-content"
    @input="$emit('input', $event)"
  >
    <v-card class="modal-container">
      <div class="modal-header">
        <button class="btn-close" @click="onClose">
          <v-icon class="icon-close">
            mdi-close
          </v-icon>
        </button>
      </div>

      <div class="modal-content">
        <div v-html="html" class="html-content"></div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PaymentModalPromotion',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    html: {
      type: String,
      default: '',
    },
  },

  methods: {
    onClose() {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="stylus" scoped>
.modal-container {
    display: flex;
    flex-direction: column;

    padding: 24px;
    margin 0 auto !important
    width 100%
    max-width 100dvw
    min-width 100%
    position relative

    @media screen and (min-width: 768px) {
        width 100%
        min-width 692px
        max-width 692px
    }

    @media screen and (min-width: 1024px) {
        width 100%
        max-width 1029px
    }
}

.modal-header {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 16px;

    margin-bottom: 16px;

    .headline-l {
        flex: 1;
    }
}

.modal-content {
    width: 100%;
    max-height: 75vh;
    overflow-y: auto;
}

.btn-close {
    width: 40px;
    height: 40px;
    flex-shrink: 0;

    background: #e8e8e8;
    border-radius: 50% !important;

    z-index: 10;

    &:hover {
        .icon-close {
            color: rgba(0, 0, 0, 0.72);
        }
    }

    &:focus {
        outline: .125rem solid #0071e3;
        outline-offset: .125rem;
    }

    .icon-close {
        color: rgba(18, 18, 18, 0.56);
    }
}
</style>
